export default __webpack_public_path__ + "static/media/login.f54fb1b7.mp4";